import { lazy, Suspense, useEffect, useState } from "react";

const SalonsMapInner = lazy(() => import("./SalonsMap").then((m) => ({ default: m.SalonsMap })));

export function SalonsMapClient() {
  const [mounted, setMounted] = useState(false);
  const [show, setShow] = useState(false);

  useEffect(() => {
    setMounted(true);
    const mql = window.matchMedia("(min-width: 768px)");
    const update = () => setShow(mql.matches);
    update();
    mql.addEventListener("change", update);
    return () => mql.removeEventListener("change", update);
  }, []);

  if (!mounted || !show) {
    return <div className="rounded-2xl bg-muted animate-pulse" style={{ height: 520 }} />;
  }

  return (
    <Suspense fallback={<div className="rounded-2xl bg-muted animate-pulse" style={{ height: 520 }} />}>
      <SalonsMapInner />
    </Suspense>
  );
}
